var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "npvContainer" }, [
    _c(
      "div",
      { staticClass: "innerContainer" },
      [
        _c("v-card", { staticClass: "cardLeft" }, [
          _c("span", { staticClass: "headerSpanLeft" }, [
            _vm._v("Simulations Configuration")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "infoContainer",
              staticStyle: { "margin-top": "43px" }
            },
            [
              _c(
                "div",
                [
                  _c("v-icon", { staticStyle: { color: "#4fa2b7" } }, [
                    _vm._v(" mdi-label-variant-outline ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "infoLabel" }, [_vm._v("Label")])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "infoValue" }, [
                  _vm._v(_vm._s(_vm.simulation[0].smlr_label))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "infoContainer",
              staticStyle: { "margin-top": "32px" }
            },
            [
              _c(
                "div",
                [
                  _c("v-icon", { staticStyle: { color: "#4fa2b7" } }, [
                    _vm._v(" rule ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "infoLabel" }, [_vm._v("Status")])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "infoValue" }, [
                  _vm._v(_vm._s(_vm.simulation[0].smlr_status))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "infoContainer",
              staticStyle: { "margin-top": "32px" }
            },
            [
              _c(
                "div",
                [
                  _c("v-icon", { staticStyle: { color: "#4fa2b7" } }, [
                    _vm._v(" mdi-account-outline ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "infoLabel" }, [
                    _vm._v("Created by")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "infoValue" }, [
                  _vm._v(_vm._s(_vm.simulation[0].smlr_user_id))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "infoContainer",
              staticStyle: { "margin-top": "32px" }
            },
            [
              _c(
                "div",
                [
                  _c("v-icon", { staticStyle: { color: "#4fa2b7" } }, [
                    _vm._v(" mdi-calendar-month ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "infoLabel" }, [
                    _vm._v("Created at")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "infoValue" }, [
                  _vm._v(_vm._s(_vm.simulation[0].smlr_created_at))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "infoContainer",
              staticStyle: { "margin-top": "32px" }
            },
            [
              _c(
                "div",
                [
                  _c("v-icon", { staticStyle: { color: "#4fa2b7" } }, [
                    _vm._v(" mdi-update ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "infoLabel" }, [
                    _vm._v("Updated at")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "infoValue" }, [
                  _vm._v(_vm._s(_vm.simulation[0].smlr_updated_at))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "buttonContainer" }, [
            false
              ? _c(
                  "span",
                  {
                    staticClass: "deleteButton",
                    on: { click: _vm.deleteButtonHandler }
                  },
                  [_vm._v("Delete")]
                )
              : _vm._e(),
            _vm._v(" "),
            false
              ? _c(
                  "span",
                  {
                    staticClass: "downloadButton",
                    on: { click: _vm.downloadButtonHandler }
                  },
                  [_vm._v("Download Configuration")]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rightContainer" },
          [
            _c("v-card", { staticClass: "cardTabs" }, [
              _c(
                "div",
                [
                  _c("tabs", {
                    attrs: { tabs: _vm.tabs, activeTab: _vm.activeTab },
                    on: {
                      startTabChange: function($event) {
                        return _vm.tabHandler($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actionsTitleContainer" },
                [
                  _c("v-text-field", {
                    staticClass: "layer-search",
                    attrs: {
                      "prepend-inner-icon": "search",
                      label: _vm.$t("Search"),
                      placeholder: _vm.$t("Search"),
                      "single-line": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "actionButtons",
                      staticStyle: {
                        "margin-left": "16px",
                        "margin-right": "8px"
                      },
                      attrs: { color: "#67A0B4" }
                    },
                    [_c("v-icon", [_vm._v(" mdi-refresh ")])],
                    1
                  ),
                  _vm._v(" "),
                  false
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "actionButtons",
                          staticStyle: { "margin-right": "8px" },
                          attrs: { color: "#67A0B4" }
                        },
                        [_c("v-icon", [_vm._v(" cloud_upload ")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "actionButtons",
                      attrs: { color: "#67A0B4" },
                      on: { click: _vm.downloadSimulationsReport }
                    },
                    [_c("v-icon", [_vm._v(" file_download ")])],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "v-tabs-items",
              {
                key: _vm.activeTab,
                staticClass: "itemContainer",
                model: {
                  value: _vm.activeTab,
                  callback: function($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab"
                }
              },
              [
                _c("v-tab-item", { attrs: { value: 0 } }, [
                  _c(
                    "div",
                    { staticClass: "divDiogo" },
                    [
                      _c("v-card", { staticClass: "mapCardContainer" }, [
                        _c(
                          "div",
                          { staticClass: "mapContainer" },
                          [
                            _c("new-map", { key: _vm.tableOpen, ref: "newMap" })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "radioGroupContainer" },
                          [
                            _c(
                              "div",
                              { staticClass: "checkBoxContainer" },
                              _vm._l(_vm.report.buildings, function(
                                building,
                                index
                              ) {
                                return _c("v-checkbox", {
                                  key: building.percentage,
                                  attrs: {
                                    label: building.percentage,
                                    color: _vm.colorsArray[index],
                                    "on-icon": "mdi-radiobox-marked",
                                    "off-icon": "mdi-radiobox-blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.percentageSelection(
                                        building,
                                        index
                                      )
                                    }
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _vm.tableOpen === false
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "openTableButton",
                                    staticStyle: { "margin-right": "8px" },
                                    attrs: { color: "#67A0B4" },
                                    on: { click: _vm.tableOpenHandler }
                                  },
                                  [_c("v-icon", [_vm._v("table_chart")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.tableOpen === true
                        ? _c("v-card", { staticClass: "tablePerc" }, [
                            _c(
                              "div",
                              { staticClass: "tableButtonContainer" },
                              [
                                _vm.tableOpen === true
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "openTableButton",
                                        staticStyle: { "margin-right": "8px" },
                                        attrs: { color: "#67A0B4" },
                                        on: { click: _vm.tableOpenHandler }
                                      },
                                      [_c("v-icon", [_vm._v("table_chart")])],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  width: "100%",
                                  overflow: "auto",
                                  "max-height": "78%"
                                }
                              },
                              [
                                _c("AtesioTable", {
                                  attrs: {
                                    rows: _vm.report.report.data,
                                    colors: _vm.colorsArrayOpacity
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("v-tab-item", { attrs: { value: 1 } }, [
                  _c(
                    "div",
                    { staticClass: "divDiogo" },
                    [
                      _c("v-card", { staticClass: "mapCardContainer" }, [
                        _c(
                          "div",
                          { staticClass: "tableContainer" },
                          [
                            _c("v-data-table", {
                              staticClass: "buildingsTable",
                              attrs: {
                                headers: _vm.headersBuildings,
                                items: _vm.filteredBuildings,
                                "item-key": "name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "radioGroupContainer" },
                          [
                            _c(
                              "div",
                              { staticClass: "checkBoxContainer" },
                              _vm._l(_vm.report.buildings, function(
                                building,
                                index
                              ) {
                                return _c("v-checkbox", {
                                  key: building.percentage,
                                  attrs: {
                                    label: building.percentage,
                                    color: _vm.colorsArray[index],
                                    "on-icon": "mdi-radiobox-marked",
                                    "off-icon": "mdi-radiobox-blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.percentageSelectionBuildings(
                                        building,
                                        index
                                      )
                                    }
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _vm.tableOpen === false
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "openTableButton",
                                    staticStyle: { "margin-right": "8px" },
                                    attrs: { color: "#67A0B4" },
                                    on: { click: _vm.tableOpenHandler }
                                  },
                                  [_c("v-icon", [_vm._v("table_chart")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.tableOpen === true
                        ? _c("v-card", { staticClass: "tablePerc" }, [
                            _c(
                              "div",
                              { staticClass: "tableButtonContainer" },
                              [
                                _vm.tableOpen === true
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "openTableButton",
                                        staticStyle: { "margin-right": "8px" },
                                        attrs: { color: "#67A0B4" },
                                        on: { click: _vm.tableOpenHandler }
                                      },
                                      [_c("v-icon", [_vm._v("table_chart")])],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  width: "100%",
                                  overflow: "auto",
                                  "max-height": "78%"
                                }
                              },
                              [
                                _c("AtesioTable", {
                                  attrs: {
                                    rows: _vm.report.report.data,
                                    colors: _vm.colorsArrayOpacity
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("v-tab-item", { attrs: { value: 2 } }, [
                  _c(
                    "div",
                    { staticClass: "divDiogo" },
                    [
                      _c("v-card", { staticClass: "mapCardContainer" }, [
                        _c(
                          "div",
                          { staticClass: "tableContainer" },
                          [
                            _c("v-data-table", {
                              staticClass: "buildingsTable",
                              attrs: {
                                headers: _vm.headersPathways,
                                items: _vm.filteredPathways,
                                "item-key": "name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "radioGroupContainer" },
                          [
                            _c(
                              "div",
                              { staticClass: "checkBoxContainer" },
                              _vm._l(_vm.report.buildings, function(
                                building,
                                index
                              ) {
                                return _c("v-checkbox", {
                                  key: building.percentage,
                                  attrs: {
                                    label: building.percentage,
                                    color: _vm.colorsArray[index],
                                    "on-icon": "mdi-radiobox-marked",
                                    "off-icon": "mdi-radiobox-blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.percentageSelectionPathways(
                                        building,
                                        index
                                      )
                                    }
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _vm.tableOpen === false
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "openTableButton",
                                    staticStyle: { "margin-right": "8px" },
                                    attrs: { color: "#67A0B4" },
                                    on: { click: _vm.tableOpenHandler }
                                  },
                                  [_c("v-icon", [_vm._v("table_chart")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.tableOpen === true
                        ? _c("v-card", { staticClass: "tablePerc" }, [
                            _c(
                              "div",
                              { staticClass: "tableButtonContainer" },
                              [
                                _vm.tableOpen === true
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "openTableButton",
                                        staticStyle: { "margin-right": "8px" },
                                        attrs: { color: "#67A0B4" },
                                        on: { click: _vm.tableOpenHandler }
                                      },
                                      [_c("v-icon", [_vm._v("table_chart")])],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  width: "100%",
                                  overflow: "auto",
                                  "max-height": "78%"
                                }
                              },
                              [
                                _c("AtesioTable", {
                                  attrs: {
                                    rows: _vm.report.report.data,
                                    colors: _vm.colorsArrayOpacity
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-083ec426", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083ec426","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/NpvConfiguration.vue
// module id = null
// module chunks = 